import { createAction, handleActions } from 'redux-actions';
import { takeLatest, call } from 'redux-saga/effects';
import * as userAPI from '../../lib/api/userapi';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { utils } from '../../../node_modules/jest-snapshot/build/index';
import { DeCryptData } from '../../lib/util/CustomUtil';


// 회원 정보 가져오기  
const [INFO, INFO_SUCCESS, INFO_FAILURE] = createRequestActionTypes(
    'userinfo/INFO',
);

// 마케팅 동의 정보 업데이트 
const [MRKT, MRKT_SUCCESS, MRKT_FAILURE] = createRequestActionTypes(
    'userinfo/MRKT',
);

const [MRKT_INFO, MRKT_INFO_SUCCESS, MRKT_INFO_FAILURE] = createRequestActionTypes(
    'userinfo/MRKT_INFO',
);

// 회원 정보 업데이트 
const [UPDATE_INFO, UPDATE_INFO_SUCCESS, UPDATE_INFO_FAILURE] = createRequestActionTypes(
    'userinfo/UPDATE_INFO',
);

// 회원 클립 정보 가져오기  
const [CLIP, CLIP_SUCCESS, CLIP_FAILURE] = createRequestActionTypes(
    'userinfo/CLIP',
);

// 회원 닉네임 정보 업데이트 
const [UPDATE_NICK_INFO, UPDATE_NICK_INFO_SUCCESS, UPDATE_NICK_INFO_FAILURE] = createRequestActionTypes(
    'userinfo/UPDATE_NICK_INFO',
);

// 회원 탈퇴 정보 업데이트 
const [DROP, DROP_SUCCESS, DROP_FAILURE] = createRequestActionTypes(
    'userinfo/DROP',
);

//좋아요 상품 가져오기
const [
    REQ_TYPE_USER_PROD_CLIP,
    REQ_TYPE_USER_PROD_CLIP_SUCCESS,
    REQ_TYPE_USER_PROD_CLIP_FAILURE,
] = createRequestActionTypes('userinfo/PROD_CLIP');

//좋아요 상품 더보기 가져오기
const [
    REQ_TYPE_USER_PROD_CLIP_ADD_VIEW,
    REQ_TYPE_USER_PROD_CLIP_ADD_VIEW_SUCCESS,
    REQ_TYPE_USER_PROD_CLIP_ADD_VIEW_FAILURE,
] = createRequestActionTypes('userinfo/PROD_CLIP_ADD_VIEW');

//좋아요 공간 가져오기
const [
    REQ_TYPE_USER_SPACE_CLIP,
    REQ_TYPE_USER_SPACE_CLIP_SUCCESS,
    REQ_TYPE_USER_SPACE_CLIP_FAILURE,
] = createRequestActionTypes('userinfo/SPACE_CLIP');

//좋아요 공간 더보기 가져오기
const [
    REQ_TYPE_USER_SPACE_CLIP_ADD_VIEW,
    REQ_TYPE_USER_SPACE_CLIP_ADD_VIEW_SUCCESS,
    REQ_TYPE_USER_SPACE_CLIP_ADD_VIEW_FAILURE,
] = createRequestActionTypes('userinfo/SPACE_CLIP_ADD_VIEW');

const RESETINFO = createRequestActionTypes('userinfo/RESETINFO');
const CLEARERR = createRequestActionTypes('userinfo/CLEARERR');
const CLIP_SORT = createRequestActionTypes('userinfo/CLIP_SORT');

const SET_CLIP_PRODUCT = createRequestActionTypes('userinfo/SET_CLIP_PRODUCT');
const SET_CLIP_SPACE = createRequestActionTypes('userinfo/SET_CLIP_SPACE');
const SET_CLIP_INFO = createRequestActionTypes('userinfo/SET_CLIP_INFO');

const SET_SUB_MENU = createRequestActionTypes('userinfo/SET_SUB_MENU');
const SET_DEFAULT_VALUE_PRODUCT = createRequestActionTypes('userinfo/SET_DEFAULT_VALUE_PRODUCT');

// Action 정의 
export const userInfoAction = createAction(INFO);
export const userInfoResetAction = createAction(RESETINFO);
export const userMrktAction = createAction(MRKT, (sms, email, kakao) => ({ sms, email, kakao }));
export const userMrktInfoAction = createAction(MRKT_INFO);
export const userInfoUpdateAction = createAction(UPDATE_INFO, (confirmData) => ({ confirmData }));
export const userNickInfoUpdateAction = createAction(UPDATE_NICK_INFO, (nickname) => ({ nickname }));
export const userErrClearAction = createAction(CLEARERR);
export const userClipAction = createAction(CLIP, (param) => ({ param }));
export const userClipSortAction = createAction(CLIP_SORT);
export const prodClipAction = createAction(REQ_TYPE_USER_PROD_CLIP, (email, brandid, offset, limit) => {
    return { email, brandid, offset, limit }
});
export const prodClipAddAction = createAction(REQ_TYPE_USER_PROD_CLIP_ADD_VIEW, (email, brandid, offset, limit) => {
    return { email, brandid, offset, limit }
});
export const userClipProductAction = createAction(SET_CLIP_PRODUCT);
export const userClipSpaceAction = createAction(SET_CLIP_SPACE);
export const userClipInfoAction = createAction(SET_CLIP_INFO);
export const setSubMenuAction = createAction(SET_SUB_MENU);
export const setDefautlValueProductAction = createAction(SET_DEFAULT_VALUE_PRODUCT);
export const spaceClipAction = createAction(REQ_TYPE_USER_SPACE_CLIP, (email, offset, limit) => {
    return { email, offset, limit }
});
export const spaceClipAddAction = createAction(REQ_TYPE_USER_SPACE_CLIP_ADD_VIEW, (email, offset, limit) => {
    return { email, offset, limit }
});
export const userDropAction = createAction(DROP, (drop_reason, drop_reason_detail) => ({ drop_reason, drop_reason_detail }));

// Make Saga I/F
const getUserInfoSaga = createRequestSaga(INFO, userAPI.getUserInfo);
const setUserMrktSaga = createRequestSaga(MRKT, userAPI.setUserMrkt);
const getUserMrktSaag = createRequestSaga(MRKT_INFO, userAPI.getUserMrkt);
const setUserInfoUpdateSaga = createRequestSaga(UPDATE_INFO, userAPI.setUserInfoUpdate);
const setUserNickInfoUpdateSaga = createRequestSaga(UPDATE_NICK_INFO, userAPI.setUserNickInfoUpdate);
const setUserClipSaga = createRequestSaga(CLIP, userAPI.getUserClip);
const getUserClipProdSaga = createRequestSaga(REQ_TYPE_USER_PROD_CLIP, userAPI.getUserClipProd);
const getUserClipProdAddSaga = createRequestSaga(REQ_TYPE_USER_PROD_CLIP_ADD_VIEW, userAPI.getUserClipProd);
const getUserClipSpaceSaga = createRequestSaga(REQ_TYPE_USER_SPACE_CLIP, userAPI.getUserClipSpace);
const getUserClipSpaceAddSaga = createRequestSaga(REQ_TYPE_USER_SPACE_CLIP_ADD_VIEW, userAPI.getUserClipSpace);
const setUserDropSaga = createRequestSaga(DROP, userAPI.setUserDrop);

export function* userInfoSaga() {
    yield takeLatest(INFO, getUserInfoSaga);
    yield takeLatest(MRKT, setUserMrktSaga);
    yield takeLatest(MRKT_INFO, getUserMrktSaag);
    yield takeLatest(UPDATE_INFO, setUserInfoUpdateSaga);
    yield takeLatest(UPDATE_NICK_INFO, setUserNickInfoUpdateSaga);
    yield takeLatest(CLIP, setUserClipSaga);
    yield takeLatest(REQ_TYPE_USER_PROD_CLIP, getUserClipProdSaga);
    yield takeLatest(REQ_TYPE_USER_PROD_CLIP_ADD_VIEW, getUserClipProdAddSaga);
    yield takeLatest(REQ_TYPE_USER_SPACE_CLIP, getUserClipSpaceSaga);
    yield takeLatest(REQ_TYPE_USER_SPACE_CLIP_ADD_VIEW, getUserClipSpaceAddSaga);
    yield takeLatest(DROP, setUserDropSaga);
}

/**
 * 리덕스 모듈 초기값 
 */
const initialState = {
    code: null,
    action: null,
    nickname: null,
    sex: null,
    birth: null,
    mobile: null,
    name: null,
    mrkt_email_yn: null,
    mrkt_sms_yn: null,
    mrkt_kakao_yn: null,
    nick_date: null,
    clipinfo: null,
    clipBrand: null,
    clipProd: null,
    clipSpace: null,
    err: null,
    msg1: null,
    msg2: null,
    msg3: null,
    sort: 0,
    subMenu: 0,
    defaultValueProduct:{brnd_id: 0, brnd_han: "전체보기", countprdt:0 }, //상품찜 기본 값
};

/**
 * 리덕스 액션 연결 
 */
const userInfoReducer = handleActions(
    {
        [INFO_SUCCESS]: (state, { payload }) => {
            state.action = INFO_SUCCESS;
            if (payload.code === 200) {
                let decode = DeCryptData(payload.message);
                state.code = 200;
                state.birth = decode[0].birth;
                state.nickname = decode[0].nickname;
                state.sex = decode[0].sex;
                state.name = decode[0].name;
                state.mobile = decode[0].mobile;
                state.mrkt_email_yn = decode[0].mrkt_email_yn;
                state.mrkt_sms_yn = decode[0].mrkt_sms_yn;
                state.mrkt_kakao_yn = decode[0].mrkt_kakao_yn;
                state.nick_date = decode[0].nick_date;
            }

            return ({
                ...state,
            })
        },
        [INFO_FAILURE]: (state) => ({
            ...state,
            code: null,
            action: null,
            nickname: null,
            sex: null,
            birth: null,
            mobile: null,
            name: null,
            mrkt_email_yn: null,
            mrkt_sms_yn: null,
            mrkt_kakao_yn: null,
            msg1: null,
            msg2: null,
            msg3: null,
            nick_date: null,
        }),
        [RESETINFO]: state => ({
            ...state,
            code: null,
            action: null,
            nickname: null,
            sex: null,
            birth: null,
            mobile: null,
            name: null,
            mrkt_email_yn: null,
            mrkt_sms_yn: null,
            mrkt_kakao_yn: null,
            msg1: null,
            msg2: null,
            msg3: null
        }),

        [UPDATE_INFO_SUCCESS]: (state, { payload }) => {
            state.action = UPDATE_INFO_SUCCESS;

            state.code = payload.code;
            if (state.code !== 200) {
                state.err = payload.message;
            }

            return ({
                ...state,
            })
        },
        [UPDATE_INFO_FAILURE]: (state, { payload: error }) => {
            state.action = UPDATE_INFO_FAILURE;
            return ({
                ...state,
                code: 0,
                err: error
            })
        },
        [UPDATE_NICK_INFO_SUCCESS]: (state, { payload }) => {
            state.action = UPDATE_NICK_INFO_SUCCESS;

            state.code = payload.code;
            if (state.code !== 200) {
                state.err = payload.message;
            }

            return ({
                ...state,
            })
        },
        [UPDATE_NICK_INFO_FAILURE]: (state, { payload: error }) => {
            state.action = UPDATE_NICK_INFO_FAILURE;
            return ({
                ...state,
                code: 0,
                err: error
            })
        },
        [DROP_SUCCESS]: (state, { payload }) => {
            state.action = DROP_SUCCESS;

            state.code = payload.code;
            if (state.code !== 200) {
                state.err = payload.message;
            }

            return ({
                ...state,
            })
        },
        [DROP_FAILURE]: (state, { payload: error }) => {
            state.action = DROP_FAILURE;
            return ({
                ...state,
                code: 0,
                err: error
            })
        },
        [CLEARERR]: state => ({
            ...state,
            code: null,
            action: null,
            err: null,
            msg1: null,
            msg2: null,
            msg3: null
        }),
        [CLIP_SUCCESS]: (state, { payload }) => {
            state.action = CLIP_SUCCESS;
            state.code = payload.code;
            state.clipinfo = payload.clipinfo;
            state.clipProd = payload.clipinfo.prod;
            state.clipSpace = payload.clipinfo.space;
            return ({
                ...state,
            })
        },
        [CLIP_FAILURE]: (state) => ({
            ...state,
            code: null,
            action: null,
            clipinfo: null,
        }),
        [MRKT_SUCCESS]: (state, { payload }) => {
            state.action = MRKT_SUCCESS;
            state.code = payload.code;
            state.msg1 = payload.msg1;
            state.msg2 = payload.msg2;
            state.msg3 = payload.msg3;
            return ({
                ...state,
            })
        },
        [MRKT_FAILURE]: (state) => ({
            ...state,
            code: null,
            action: null,
            msg1: null,
            msg2: null,
            msg3: null
        }),

        [MRKT_INFO_SUCCESS]: (state, { payload }) => {
            state.action = MRKT_INFO_SUCCESS;
            state.code = payload.code;
            state.mrkt_email_yn = payload.message.mrkt_email_yn;
            state.mrkt_sms_yn = payload.message.mrkt_sms_yn;
            state.mrkt_kakao_yn = payload.message.mrkt_kakao_yn;

            return ({
                ...state,
            })
        },
        [MRKT_INFO_FAILURE]: (state) => ({
            ...state,
            code: null,
            action: null,
            msg1: null,
            msg2: null,
            msg3: null
        }),
        [CLIP_SORT]: (state, { payload: sort }) => {
            return ({
                ...state,
                sort: sort,
                action: CLIP_SORT
            })
        },
        [REQ_TYPE_USER_PROD_CLIP_SUCCESS]: (state, { payload }) => {
            state.action = REQ_TYPE_USER_PROD_CLIP_SUCCESS;
            state.clipProd = payload;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_USER_PROD_CLIP_FAILURE]: (state) => ({
            ...state,
            code: null,
            action: null,
            clipProd: null,
        }),
        [REQ_TYPE_USER_PROD_CLIP_ADD_VIEW_SUCCESS]: (state, { payload }) => {
            let dataList = state.clipProd.concat(payload);
            state.action = REQ_TYPE_USER_PROD_CLIP_ADD_VIEW_SUCCESS;
            state.clipProd = dataList;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_USER_PROD_CLIP_ADD_VIEW_FAILURE]: (state) => ({
            ...state,
            code: null,
            action: null,
            clipProd: null,
        }),
        [SET_CLIP_PRODUCT]: (state, { payload }) => {
            state.clipProd = payload;
            return ({
                ...state,
            })
        },
        [SET_CLIP_INFO]: (state, { payload }) => {
            state.clipinfo = payload;
            return ({
                ...state,
            })
        },
        [SET_SUB_MENU]: (state, { payload }) => {
            state.subMenu = payload;
            return ({
                ...state,
            })
        },
        [SET_DEFAULT_VALUE_PRODUCT]: (state, { payload }) => {
            state.defaultValueProduct = payload;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_USER_SPACE_CLIP_SUCCESS]: (state, { payload }) => {
            state.action = REQ_TYPE_USER_SPACE_CLIP_SUCCESS;
            state.clipSpace = payload;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_USER_SPACE_CLIP_FAILURE]: (state) => ({
            ...state,
            code: null,
            action: null,
            clipSpace: null,
        }),
        [REQ_TYPE_USER_SPACE_CLIP_ADD_VIEW_SUCCESS]: (state, { payload }) => {
            let dataList = state.clipSpace.concat(payload);
            state.action = REQ_TYPE_USER_SPACE_CLIP_ADD_VIEW_SUCCESS;
            state.clipSpace = dataList;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_USER_SPACE_CLIP_ADD_VIEW_FAILURE]: (state) => ({
            ...state,
            code: null,
            action: null,
            clipSpace: null,
        }),
        [SET_CLIP_SPACE]: (state, { payload }) => {
            state.clipSpace = payload;
            return ({
                ...state,
            })
        },
    },
    initialState,
);

export default userInfoReducer;